export type LevelDetailsNavigation = {
  nextPosition: number | null;
  previousPosition: number | null;
};

export function getLevelDetailsNavigation(
  activePosition: number,
  levelCount: number,
): LevelDetailsNavigation {
  return {
    nextPosition: activePosition < levelCount - 1 ? activePosition + 1 : null,
    previousPosition: activePosition > 0 ? activePosition - 1 : null,
  };
}
